import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import './Button.scss'

const Button = ({ ariaLabel, children, className, disabled, model, onClick, purple, radius, size, type='button', shake }) => (
    <button className={cx('button', model, size, radius, className, purple && 'purple', shake && 'shake')}
            type={type}
            onClick={onClick}
            aria-label={ariaLabel}
            disabled={disabled}>
        {children}
    </button>
)

Button.propTypes = {
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.any,
    model: PropTypes.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: PropTypes.string,
    type: PropTypes.oneOf(['button', 'submit']),
    radius: PropTypes.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
}

export default Button



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Button/Button.jsx